import { render } from "./cp_icon.vue?vue&type=template&id=a17d9f2c&scoped=true"
import script from "./cp_icon.vue?vue&type=script&lang=js"
export * from "./cp_icon.vue?vue&type=script&lang=js"

import "./cp_icon.vue?vue&type=style&index=0&id=a17d9f2c&scoped=scoped&lang=less"

import exportComponent from "D:\\Work\\高报云\\代码和文档\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a17d9f2c"]])

export default __exports__